define.alias("shared/components/shared/carousel/inner", "preview-grid/components/shared/carousel/inner");